<template>
  <div>
    <div
      v-if="createdRecipes.length > 0"
      class="max-w-[1280px] mx-auto py-8 px-6"
    >
      <h1 class="text-4xl font-bold">Mina recept</h1>
      <div class="grid grid-cols-1 lg:grid-cols-4 gap-4 mt-8">
        <RecipeCard
          v-for="recipe in createdRecipes"
          :key="recipe.id"
          :recipe="recipe"
          :current-user="currentUser"
          :csrf-token="csrfToken"
        />
      </div>
    </div>

    <div class="max-w-[1280px] mx-auto py-8 px-6">
      <h1 class="text-4xl font-bold">Gillade recept</h1>
      <div
        v-if="likedRecipes.length > 0"
        id="recipes"
        class="grid grid-cols-1 lg:grid-cols-4 gap-4 mt-8"
      >
        <RecipeCard
          v-for="recipe in likedRecipes"
          :key="recipe.id"
          :recipe="recipe"
          :current-user="currentUser"
          :csrf-token="csrfToken"
        />
      </div>
      <p v-else class="text-lg mt-4">Du har inte gillat några recept än.</p>
    </div>
  </div>
</template>

<script setup>
import RecipeCard from "@/components/recipe/RecipeCard.vue";

defineProps({
  createdRecipes: { type: Array, default: () => [] },
  likedRecipes: { type: Array, default: () => [] },
  currentUser: { type: Object, default: null },
  csrfToken: { type: String, default: "" },
});
</script>
